import { FC, useCallback } from 'react';
import { useSnapshot } from 'valtio';
import { createInvitation } from '../actions/invite-user-actions';
import InviteUserModal from '../components/InviteUserModal';
import { InvitationInput, Role } from '../types/members-types';
import InviteMemberStore from '../stores/invite-user-store';
import { closeInviteUserModal } from '../store-actions/invite-user-store-actions';

const InviteUserContainer: FC<
  React.PropsWithChildren<InviteUserContainerProps>
> = ({ availableRoles }) => {
  const {
    isModalVisible,
    isInviteButtonEnabled,
    isInviteButtonLoading,
    hasErrorMessage,
    errorMessage,
  } = useSnapshot(InviteMemberStore);

  const onInvite = useCallback(async (invitationInput: InvitationInput) => {
    await createInvitation(invitationInput);
  }, []);

  if (!isModalVisible) {
    return null;
  }

  return (
    <InviteUserModal
      open={isModalVisible}
      onClose={closeInviteUserModal}
      onInvite={onInvite}
      availableRoles={availableRoles}
      isInviteEnabled={isInviteButtonEnabled}
      isInviteButtonLoading={isInviteButtonLoading}
      hasErrorMessage={hasErrorMessage}
      errorMessage={errorMessage}
    />
  );
};

export interface InviteUserContainerProps {
  availableRoles: Role[];
}

export default InviteUserContainer;
